import { Component } from "@angular/core";
import bwipjs from "@bwip-js/browser";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplatePreviewComponent } from "../../templates/template-preview/template-preview.component";

@Component({
  selector: "app-prefix-bar",
  imports: [TemplatePreviewComponent],
  templateUrl: "./prefix-bar.component.html",
  styleUrl: "./prefix-bar.component.less",
})
export class PrefixBarComponent extends PrefixTextComponent {
  public preview: string | null = null;

  public constructor() {
    super({ updateOn: "blur" });
    this.characters = ALLOWED_CHARACTERS["bar"];
  }

  public setBarcode(context: TemplatePreviewComponent): void {
    const canvas = context.getCanvas();
    context.updateCanvas((resolve, reject) => {
      try {
        this.preview = bwipjs
          .toCanvas(canvas, { text: this.control.value || "", bcid: "code128", includetext: true, height: 6, width: 24 })
          .toDataURL();
        resolve("success");
      } catch (err) {
        reject("unable to load barcode.");
      }
    });
  }
}
